import { useCallback, useState } from "react";
import { ButtonWrap } from "@hopper-b2b/ui";
import clsx from "clsx";
import Chevron from "../../../assets/client/chevron.svg?react";
import DollarCoin from "../../../assets/client/coin.svg?react";
import { useEnhancedEarnAmount } from "../../../hooks/shared";
import { EnhancedEarnPopover } from "../EnhancedEarnPopover";
import styles from "./styles.module.scss";

export const EnhancedEarnRow = ({
  totalPrice,
  className,
  hasLearnMore = false,
  onClick,
  hasExtraContent = false,
}: {
  totalPrice: number;
  className?: string;
  hasLearnMore?: boolean;
  onClick?: () => void;
  hasExtraContent?: boolean;
}) => {
  const [openLearnMore, setOpenLearnMore] = useState(false);
  const {
    isEnhancedEarnEnabled,
    pointsEarnedWithMultiplerCopy,
    pointsEarnedByDollarCopy,
  } = useEnhancedEarnAmount();

  const openLearnMoreHandler = useCallback(() => {
    if (hasLearnMore) {
      onClick ? onClick() : setOpenLearnMore(!openLearnMore);
    }
  }, [hasLearnMore, openLearnMore, onClick]);

  return isEnhancedEarnEnabled ? (
    <>
      <ButtonWrap
        onClick={openLearnMoreHandler}
        className={clsx(styles.EnhancedEarnRow, className)}
      >
        <DollarCoin className="icon" />
        <p className="copy">{pointsEarnedWithMultiplerCopy(totalPrice)}</p>
        <p className={clsx("copy", "compact")}>{pointsEarnedByDollarCopy()}</p>
        {hasLearnMore ? <Chevron className="learn-more" /> : null}
      </ButtonWrap>
      {hasLearnMore ? (
        <EnhancedEarnPopover
          isOpen={openLearnMore}
          onClose={openLearnMoreHandler}
          totalPrice={totalPrice}
          isExtended={hasExtraContent}
        />
      ) : null}
    </>
  ) : null;
};
